const COOKIE_NAME = "app_attribution_data";
const TRANSACTION_ID_COOKIE_NAME = "transaction_id";
const COOKIE_MAX_AGE_SECONDS = 7 * 24 * 60 * 60; // 7 days

// Kept separate from app_attribution_data: which funnel a visitor is on isn't
// Everflow attribution, and shouldn't depend on Everflow params being present.
const PRICE_VARIANT_COOKIE_NAME = "price_variant";

export interface AttributionData {
  utm_campaign?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_content?: string;
  oid?: string;
  affid?: string;
  cio_id?: string;
  _ef_transaction_id?: string;
  source_id?: string;
  uid?: string;
  sub1?: string;
  sub2?: string;
  sub3?: string;
  sub4?: string;
  sub5?: string;
}

const getCookieValue = (name: string, fallbackName: string): string | null => {
  const cookies = document.cookie
    .split(";")
    .reduce<Record<string, string>>((acc, cookie) => {
      const [key, value] = cookie.trim().split("=") as [string, string];
      acc[key] = value;
      return acc;
    }, {});

  return cookies[name] ?? cookies[fallbackName] ?? null;
};

export const getCookie = (name: string): string | null =>
  getCookieValue(name, name);

export const getAttributionCookie = (): AttributionData | null => {
  try {
    const raw = getCookieValue(COOKIE_NAME, TRANSACTION_ID_COOKIE_NAME);
    if (!raw) {
      return null;
    }
    return JSON.parse(decodeURIComponent(raw)) as AttributionData;
  } catch {
    return null;
  }
};

export const setAttributionCookie = (data: AttributionData): void => {
  const encoded = encodeURIComponent(JSON.stringify(data));
  document.cookie = `${COOKIE_NAME}=${encoded}; max-age=${COOKIE_MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
};

export const getPriceVariantCookie = (): string | null =>
  getCookieValue(PRICE_VARIANT_COOKIE_NAME, PRICE_VARIANT_COOKIE_NAME);

export const setPriceVariantCookie = (value: string): void => {
  document.cookie = `${PRICE_VARIANT_COOKIE_NAME}=${encodeURIComponent(value)}; max-age=${COOKIE_MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
};

export const clearPriceVariantCookie = (): void => {
  document.cookie = `${PRICE_VARIANT_COOKIE_NAME}=; max-age=0; path=/; SameSite=Lax`;
};
